import { render, staticRenderFns } from "./WritingTask1.vue?vue&type=template&id=573bc960&scoped=true&"
import script from "./WritingTask1.vue?vue&type=script&lang=ts&"
export * from "./WritingTask1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573bc960",
  null
  
)

export default component.exports